import { render, staticRenderFns } from "./RosettesHistory.vue?vue&type=template&id=917dd01e&scoped=true&"
import script from "./RosettesHistory.vue?vue&type=script&lang=js&"
export * from "./RosettesHistory.vue?vue&type=script&lang=js&"
import style0 from "./RosettesHistory.vue?vue&type=style&index=0&id=917dd01e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "917dd01e",
  null
  
)

export default component.exports